<template>
  <smd-one-col-layout class="medicine-order-details-default program-weighnow"
                      :content-styles="contentStylesClass">
    <full-screen-loader position="fixed" v-if="loading" white-bg/>

    <div :class="{'d-medicine-order-details-default__content': $isDesktop}" v-if="serviceOrder">
      <div class="smd-form__row align-items-center m-b-30">
        <status-icon :item="serviceOrder" class="ns-large-icon"/>
        <div class="flex-col">
          <text-string class="m-b-5" label-id="txt116" :props="{strings: [orderNo]}"/>
          <div class="flex-row-center-x-spaced align-items-baseline">
            <text-string :label-id="statusTextLabelId"/>
            <span v-if="showOrderStatusUpdateDate"
                  :class="[statusDateTextColorClass]"
                  class="Body2">
              (as of {{ statusDateText }})
            </span>
          </div>
        </div>
      </div>

      <div v-if="isCancelled" class="m-b-20">
        <text-string label-id="txt273" :props="{ strings: [cancellationReason] }"/>
      </div>

      <div v-if="!isCancelled" class="m-b-20">
        <text-string label-id="txt121" class="m-b-5"/>
        <order-status-text :order="serviceOrder" class="m-b-20"/>

        <div v-if="pharmacyPartner" class="partner">
          <div class="partner-logo">
            <img :src="$options.PARTNER_ICONS[pharmacyPartner.partnercode]" :alt="pharmacyPartner.name">
            <img src="~@/assets/images/pharmacies/img047.png" alt="EduCare Logo">
            <img src="~@/assets/images/pharmacies/img041.png" alt="Southstar Drug Logo">
          </div>

          <text-string label-id="txt051"/>
          <div v-if="pharmacyPartner.partnercode === 'nspharmacy'" class="m-b-10">
            <p class="Body1">Monday - Friday: 9am-5pm</p>
            <p class="Body1">Saturday: 8am-4pm</p>
          </div>
          <div v-if="pharmacyPartner.partnercode !== 'nspharmacy'">
            <text-string v-if="pharmacyPartner.operationHoursLabelId" :label-id="pharmacyPartner.operationHoursLabelId"
                        class="m-b-10"/>
            <span v-if="!pharmacyPartner.operationHoursLabelId" class="Body1 m-b-5">-</span>
          </div>

          <text-string label-id="txt124"/>

          <div v-if="pharmacyPartner.partnercode === 'nspharmacy'">
            <p class="Body1">Monday - Friday: 5pm</p>
            <p class="Body1">Saturday: 4pm</p>
          </div>
          <text-string v-if="pharmacyPartner.partnercode !== 'nspharmacy'" :label-id="pharmacyPartner.sameDayDeliveryCutOffLabelId"/>
        </div>
      </div>

      <div class="flex-row-center-x-spaced justify-content-center">
        <smd-btn v-if="canCancel"
                 section="4"
                 variant="unselected"
                 @click="cancelOrder">
          <text-string label-id="txt267"/>
        </smd-btn>
        <smd-btn section="4"
                 :variant="primaryButtonVariant"
                 @click="onPrimaryButtonClick">
          <text-string :label-id="primaryButtonLabelId"/>
        </smd-btn>
      </div>

      <div class="divider--dotted m-t-30 m-b-30"></div>

      <div v-if="showTotalPaymentAmount" class="m-b-20">
        <text-string label-id="txt147" class="m-b-15"/>
        <text-string v-if="isConfirmedStatus"
                     label-id="txt167"
                     :props="{numbers: [serviceOrder.amount]}"/>
        <p v-if="!isConfirmedStatus" class="Body1">{{ serviceOrder.amount | currency }}</p>
      </div>

      <div v-if="addedPrescriptions.length" class="added-prescriptions m-b-35">
        <text-string label-id="txt125" class="m-b-15"/>

        <div v-for="(prescription, prescriptionIndex) in addedPrescriptions"
             :key="prescriptionIndex">
          <prescription-card v-if="prescription.token"
                             :prescription="prescription"
                             :show-coupon="!!prescription.coupons"
                             class="m-b-15">
            <div v-if="prescription.remarks && prescription.remarks !== ''" class="remarks">
              <text-string label-id="txt058" class="m-t-10"/>
              <p class="Body1">{{ prescription.remarks }}</p>
            </div>
          </prescription-card>

          <attached-file-card v-if="!prescription.token"
                              class="m-b-15"
                              :prescription="prescription"
                              :orderid="serviceOrder.orderid">
            <div v-if="prescription.remarks && prescription.remarks !== ''" class="remarks">
              <text-string label-id="txt058" class="m-t-10"/>
              <p class="Body1">{{ prescription.remarks }}</p>
            </div>
          </attached-file-card>
        </div>
      </div>

      <div class="slider-section m-b-35">
        <text-string label-id="txt1432" class="Title1"/>
        <div class="sldier">
          <slider-component :slider-details="{'opt_in': serviceOrder.opt_in}"
                            :list-components="$options.sliderCardWeighNow"/>
        </div>
      </div>

      <div v-if="serviceOrder.orderData && serviceOrder.orderData.length" class="other-items m-b-35">
        <text-string label-id="txt204" class="m-b-15"/>
        <p v-for="(item, itemIndex) in serviceOrder.orderData"
           :key="itemIndex"
           class="Body1">
          {{ item.name }} - {{ item.remarks }}
        </p>
      </div>

      <div v-if="ids.length" class="sc-pwd-id m-b-35">
        <text-string label-id="txt126" class="m-b-10"/>
        <p v-for="(id, idIndex) in ids"
           :key="idIndex"
           @click="viewId(id)">
          <text-string label-id="txt140" class="m-b-5"/>
        </p>
      </div>

      <div class="delivery-details">
        <text-string label-id="txt095" class="m-b-10"/>

        <text-string label-id="txt101" class="m-b-5"/>
        <p class="Body1" :class="$isDesktop ? 'm-b-15' : 'm-b-5'">{{ patientName }}</p>
        <text-string label-id="txt102" class="m-b-5"/>
        <p class="Body1" :class="$isDesktop ? 'm-b-15' : 'm-b-5'">{{ serviceOrder.mobilenumber }}</p>
        <text-string v-if="street" label-id="txt103" class="m-b-5"/>
        <p v-if="street" class="Body1" :class="$isDesktop ? 'm-b-15' : 'm-b-5'">{{ street }}</p>
        <text-string v-if="city" label-id="txt104" class="m-b-5"/>
        <p v-if="city" class="Body1 m-b-5">{{ city | formatCity }}</p>
      </div>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import SliderComponent from '@/components/slider-component';
  import MedicineOrderDetailsMixin from '@/mixins/services/medicine-order-details-mixin';

  import SliderCardWeighNowOptInCover from '@/components/slider-items/program-weighnow/opt-in-cover';
  import SliderCardWeighNowStorageInstructionCover from '@/components/slider-items/program-weighnow/storage-instruction-cover';
  import SliderCardWeighNowStorageInstructionOne from '@/components/slider-items/program-weighnow/storage-instruction-one';
  import SliderCardWeighNowStorageInstructionTwo from '@/components/slider-items/program-weighnow/storage-instruction-two';
  import SliderCardWeighNowStorageInstructionThree from '@/components/slider-items/program-weighnow/storage-instruction-three';
  import SliderCardWeighNowStorageInstructionFour from '@/components/slider-items/program-weighnow/storage-instruction-four';
  import SliderCardWeighNowDownloadApp from '@/components/slider-items/program-weighnow/download-app-card';

  export default {
    name: 'medicine-order-details-program-weighnow',
    components: {SliderComponent},
    mixins: [
      MedicineOrderDetailsMixin,
    ],
    sliderCardWeighNow: [
      SliderCardWeighNowOptInCover,
      SliderCardWeighNowStorageInstructionCover,
      SliderCardWeighNowStorageInstructionOne,
      SliderCardWeighNowStorageInstructionTwo,
      SliderCardWeighNowStorageInstructionThree,
      SliderCardWeighNowStorageInstructionFour,
      SliderCardWeighNowDownloadApp,
    ],
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/util.scss";

  .medicine-order-details-default.program-weighnow .partner-logo {
    @include make-grid(repeat(2, minmax(50px, 100px)), repeat(2, minmax(min-content, max-content)), 37px, 25px, justify-content-center);
    justify-items: center;

    img {
      max-height: 100%;
    }

    :first-child {
      grid-row: 1 / 2;
      grid-column: 1 / -1;

      transform: scale(1.4);
      max-width: 150px;
    }

    &> :nth-child(2) {
      border: 1px solid #E1E1E1;
    }

    & > img:not(:first-child) {
      width: 100%;
      display: block;
    }
  }
</style>
